import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toastSuccess",
  "use": "toastSuccess-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"toastSuccess\"><circle cx=\"16\" cy=\"16\" fill=\"#fff\" fill-opacity=\".2\" r=\"16\" /><path d=\"m11 15.8426 3.3431 3.492 6.6569-6.6666\" stroke=\"#fff\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol